<template>
  <div>
    <ul v-if="list.length" class="container">
      <li v-for="(item, index) in list" :key="index" class="item">
        <div class="item-header">
          <div class="item-title">
            {{ item.title }}
          </div>
        </div>

        <div class="item-images" v-if="item.imgList">
          <div v-for="(image, imageIndex) in item.imgList" :key="imageIndex" class="item-image">
            <iain-image-domain w="210" h="158" r="6" :src="image" />
          </div>
        </div>

        <div class="item-footer">上传: {{ item.memberName }} {{ item.createDate }}</div>
      </li>
    </ul>

    <van-empty v-else class="custom mini" description="暂无活动相册" />
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 20px 15px 0;

  .item {
    padding-bottom: 15px;

    .item-header {
      padding: 0 15px 15px;

      .item-title {
        position: relative;
        font-size: 30px;
        font-weight: bold;
        color: #222222;

        &::after {
          content: '';
          position: absolute;
          top: 50%;
          left: -12px;
          width: 5px;
          height: 28px;
          transform: translate(0, -50%);
          border-radius: 3px;
          background: #0076ff;
        }
      }
    }

    .item-images {
      display: flex;
      flex-wrap: wrap;

      .item-image {
        padding: 0 15px 20px;
      }
    }

    .item-footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 15px;
      color: #999999;
      transform: translateY(-10px);
    }
  }
}
</style>